import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DriverLoadAlertService {
  constructor(private http: HttpClient) {}
  // ton apis
  getDriverAlerts(data:any) {
    return this.http.get(environment.apiUrl + `driver/alerts?page=${data.page}&limit=${data.limit}` );
  }
  delete(id:any){
     return this.http.delete(environment.apiUrl + `vacant/vehicles/delete/${id}`);
  }
}
